var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opening-box[data-v-50b60411] {\n  width: 100%;\n  height: 100vh;\n  background-color: #1c89f0;\n  background-image: url(" + escape(require("../../image/bg.png")) + ");\n  background-size: auto 100%;\n  position: relative;\n  background-repeat: no-repeat;\n}\n@media screen and (max-width: 2000px) {\n.opening-box[data-v-50b60411] {\n    background-position: left center;\n}\n}\n@media screen and (min-width: 2000px) and (max-width: 2500px) {\n.opening-box[data-v-50b60411] {\n    background-position: 25% center;\n}\n}\n@media screen and (min-width: 2500px) {\n.opening-box[data-v-50b60411] {\n    background-position: 35% center;\n}\n}\n", ""]);

// exports
